import BlockObserver from './BlockObserver';

export default class Downloads {
    constructor(el) {
        this.element    = el;
        this.selectors  = el.querySelectorAll('.b-downloads__title p');
        this.loadArea   = el.querySelector('.b-downloads__downloads');
        let urlParams = new URLSearchParams(window.location.search);

        this.loadDownloads(urlParams.get('id'), this.loadArea);

        this.selectors && this.selectors.forEach((selector) => {
            selector.addEventListener('click', (event) => {
                this.selectors.forEach((selector) => {
                    selector.classList.remove('selected');
                })
                selector.classList.add('selected');
                this.loadDownloads(selector.getAttribute('postid'), this.loadArea);
            });
        })
    }

    loadDownloads(postID, loadArea) {
        this.filters		= new FormData();
        this.filters.append('postID', postID);

        fetch('/wp-admin/admin-ajax.php?action=loadDownloads', {
            method: 'POST',
            body: this.filters,
        })
        .then(response => response.json())
        .then(data => {
            if(data['results']) {
                loadArea.innerHTML = '';
                data['results'].forEach((result) => {
                    loadArea.insertAdjacentHTML('beforeend', result);
                });
            }

            window.app.blockObserver.unmount()
            new BlockObserver(document.querySelectorAll('[data-watch="true"]'))

            // Update URL with filters
            let pageURL = new URL(window.location.href);
            if(postID) {
                pageURL.searchParams.set('id', postID);
                window.history.pushState({}, '', pageURL);
            } else {
                pageURL.searchParams.delete('id');
                window.history.pushState({}, '', pageURL);
            }

            return data;
        })
    }
}